import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import VideoSourceDropdownComp from 'components/SourceDisplay/VideoSourceDropdown';
import MicrophoneDropdown from 'containers/MicrophoneDropdown/MicrophoneDropdown';
import SpeakerDropdown from 'containers/SpeakerDropdown/SpeakerDropdown';
import AudioModeChooser from 'containers/AudioModeChooser/AudioModeChooser';
import RememberButtonsComp from 'components/SourceDisplay/RememberButtons';
import PreviewVideo from 'components/PreviewVideo/PreviewVideo';
import PSTNCont from 'containers/PSTN/PSTNContainer';
import { PSTN_ID } from 'constants/AvSettingsModal';
import classes from './SourceDisplay.module.scss';

// TODO something about the router causes componentDidMount to fire twice, temp fix here
let acquireLocalStreamStarted = false;

export class JoinSourceDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoEnabled: props.defaultVideoSetting,
      audioEnabled: props.defaultAudioSetting
    };
  }

  UNSAFE_componentWillMount() {
    acquireLocalStreamStarted = !this.props.isAcquiringPrimaryStream;
  }

  componentDidMount() {
    if (acquireLocalStreamStarted &&
      !(this.props.isPSTNVisible) &&
      !this.props.isAcquiringPrimaryStream) {
      acquireLocalStreamStarted = false;
      this.props.acquireLocalPrimaryStream();
    }
  }

  componentDidUpdate() {
    if (!this.props.isAcquiringPrimaryStream) {
      if (this.props.audioDevices.length === 1 &&
        this.props.audioDevices[0].deviceId === PSTN_ID &&
        !this.props.isPSTNVisible) {
        this.props.selectAudioSource(
          PSTN_ID,
          { video: this.props.defaultVideoSetting, audio: this.props.defaultAudioSetting },
          true
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.resetPSTNVisibility();
    this.props.endLocalStream();
  }

  toggleAudio = (audioEnabled) => {
    this.setState({ audioEnabled });
  };

  toggleVideo = (videoEnabled) => {
    this.setState({ videoEnabled });
  };

  render() {
    const {
      defaultVideoSetting,
      defaultAudioSetting,
      videoDevices,
      sections,
      isPSTNVisible,
      isPSTNAvailable,
      showChooser,
      showRememberButtons,
      singlePageJoin,
      selectedAudioLabel,
      selectVideoSource,
      selectedVideoLabel,
      acquireLocalPrimaryStream,
      setAudioEnabledDefault,
      setVideoEnabledDefault,
      selectedSources,
      toggleAudioMuteSetting,
      selectAudioSource,
      selectAudioOutput,
      selectedAudioOutputId,
      selectedAudioOutputLabel,
      extension
    } = this.props;

    const audioSectionClasses = [
      singlePageJoin ? classes.leftAlign : '',
      !sections.camera ? classes.onlyAudio : ''
    ].join(' ');

    const title = (<FormattedMessage
      id="components.audioModeChooser.title"
      defaultMessage="Audio"
    />);

    return (
      <div className={classes.container}>
        <div className={classes.avPanels}>
          {sections.camera &&
            <section className={singlePageJoin ? classes.leftAlign : ''}>
              {sections.audio &&
                <div className={classes.subHeading}>
                  <FormattedMessage
                    id="components.avSettingsModal.video"
                    defaultMessage="Video"
                  />
                </div>
              }
              <div className={classes.dropdownContainer} >
                {videoDevices.length ?
                  <VideoSourceDropdownComp
                    videoDevices={videoDevices}
                    selectVideoSource={selectVideoSource}
                    defaultAudioSetting={defaultAudioSetting}
                    defaultVideoSetting={defaultVideoSetting}
                    selectedVideoLabel={selectedVideoLabel}
                  />
                  :
                  <div className={classes.emptyDropdown}>
                    <FormattedMessage
                      id="components.avSettingsModal.noCamera"
                      defaultMessage="No camera detected"
                    />
                  </div>
                }
              </div>
              <PreviewVideo defaultVideoSetting={defaultVideoSetting && this.state.videoEnabled} />
              {(showRememberButtons && videoDevices.length) ?
                <RememberButtonsComp
                  acquireLocalPrimaryStream={acquireLocalPrimaryStream}
                  setVideoEnabledDefault={setVideoEnabledDefault}
                  setAudioEnabledDefault={setAudioEnabledDefault}
                  defaultVideoSetting={defaultVideoSetting}
                  defaultAudioSetting={defaultAudioSetting}
                  selectedSources={selectedSources}
                  isPSTNVisible={isPSTNVisible}
                  toggleVideo={this.toggleVideo}
                  type="video"
                /> :
                null
              }
            </section>
          }
          {sections.audio &&
            <section className={audioSectionClasses} >
              {showChooser && <AudioModeChooser />}
              <div className={classes.audioSelection}>
                {!isPSTNVisible && <MicrophoneDropdown
                  isJoinFlowCall
                  defaultAudioSetting={defaultAudioSetting}
                  defaultVideoSetting={defaultVideoSetting}
                  showRememberButtons={showRememberButtons}
                  selectedAudioLabel={selectedAudioLabel}
                  selectAudioSource={selectAudioSource}
                  acquireLocalPrimaryStream={acquireLocalPrimaryStream}
                  setVideoEnabledDefault={setVideoEnabledDefault}
                  setAudioEnabledDefault={setAudioEnabledDefault}
                  selectedSources={selectedSources}
                  toggleAudioMuteSetting={toggleAudioMuteSetting}
                  sections={sections}
                  titleClass={showChooser ? classes.joinTitle : ''}
                  title={!isPSTNAvailable && title}
                  toggleAudio={this.toggleAudio}
                />}
                <div>
                  {!isPSTNVisible && <SpeakerDropdown
                    isJoinFlowCall
                    selectAudioOutput={selectAudioOutput}
                    defaultVideoSetting={defaultVideoSetting}
                    defaultAudioSetting={defaultAudioSetting}
                    selectedAudioOutputId={selectedAudioOutputId}
                    selectedAudioOutputLabel={selectedAudioOutputLabel}
                    titleClass={singlePageJoin ? classes.joinTitle : ''}
                  />}
                  {
                    isPSTNVisible &&
                    <PSTNCont
                      extension={extension}
                      isJoinFlowCall
                      titleClass={singlePageJoin ? classes.smallHelperText : ''}
                    />
                  }
                </div>
              </div>
            </section>
          }
        </div>
      </div>
    );
  }
}

JoinSourceDisplay.propTypes = {
  acquireLocalPrimaryStream: PT.func.isRequired,
  endLocalStream: PT.func.isRequired,
  audioDevices: PT.array.isRequired,
  videoDevices: PT.array.isRequired,
  selectedSources: PT.object,
  selectVideoSource: PT.func,
  selectAudioSource: PT.func,
  setVideoEnabledDefault: PT.func,
  setAudioEnabledDefault: PT.func,
  selectAudioOutput: PT.func,
  defaultVideoSetting: PT.bool,
  defaultAudioSetting: PT.bool,
  selectedVideoLabel: PT.string,
  selectedAudioLabel: PT.string,
  selectedAudioOutputLabel: PT.string,
  selectedAudioOutputId: PT.string,
  showRememberButtons: PT.bool,
  isAcquiringPrimaryStream: PT.bool,
  extension: PT.string,
  isPSTNVisible: PT.bool,
  isPSTNAvailable: PT.bool,
  toggleAudioMuteSetting: PT.func,
  sections: PT.object,
  singlePageJoin: PT.bool,
  resetPSTNVisibility: PT.func,
  showChooser: PT.bool
};

JoinSourceDisplay.defaultProps = {
  sections: {
    camera: true,
    audio: true
  }
};

export default JoinSourceDisplay;
